import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "youtube",
  "use": "youtube-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"youtube\"><path d=\"M18.589 5.186C19 6.745 19 10 19 10s0 3.255-.411 4.814a2.492 2.492 0 0 1-1.744 1.77C15.306 17 10 17 10 17s-5.304 0-6.845-.416a2.492 2.492 0 0 1-1.744-1.77C1 13.255 1 10 1 10s0-3.255.411-4.814a2.492 2.492 0 0 1 1.744-1.77C4.697 3 10 3 10 3s5.306 0 6.845.417c.85.232 1.518.91 1.744 1.769ZM8 13.5l6-3.5-6-3.5v7Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol